import router from "./router";
import i18n from "./i18n";

export const calendarModuleRouter = router;
export const calendarModuleI18n = i18n;
